const voiceCommunity = {
  // 获取频道信息 - 李健 - ✔
  getChannelInfo: `/authApi/voiceforum/v1/game/channelDetail`,
  // 语音频道模式切换 - 林加汉 - ✔
  modelChange: `/authApi/voiceforum/v1/game/modelChange`,
  // 频道用户列表 - 林加汉 - ✔
  getChannelUsers: `/authApi/voiceforum/v1/game/channelMembers`,
  // 频道麦上用户列表 - 林加汉 - ✔
  getChannelMicUsers: `/authApi/voiceforum/v1/game/micSeatList`,
  // 自由上下麦模式-上下麦操作 - 林加汉 - ✔
  micOperate: `/authApi/voiceforum/v1/game/micOperate`,
  // 上麦申请 - 林加汉 - ✔
  micApply: `/authApi/voiceforum/v1/game/micApply`,
  // 上麦申请列表 - 林加汉 - ✔
  applyList: `/authApi/voiceforum/v1/game/applyList`,
  // 上麦审批 - 林加汉 - ✔
  micApprove: `/authApi/voiceforum/v1/game/micApprove`,
  // 上麦邀请 - 林加汉 - ✔
  micInvite: `/authApi/voiceforum/v1/game/micInvite`,
  // 接受上麦邀请 - 林加汉 - ✔
  micReceiveInvite: `/authApi/voiceforum/v1/game/micReceiveInvite`,
  // 查询当前用户拥有的所有权限 - 苏昕 - ✔
  permission: `/authApi/voiceforum/v1/game/member/permission`,
  // 踢人下麦 - 林加汉 - ✔
  kickMic: `/authApi/voiceforum/v1/game/mic/kick`,
  // 禁言用户 - 林加汉 - ✔
  muteUser: `/authApi/voiceforum/v1/game/mute`,
  // 解除用户禁言 - 林加汉 - ✔
  unmuteUser: `/authApi/voiceforum/v1/game/unmute`,
  // 闭麦 - 林加汉 - ✔
  closeMic: `/authApi/voiceforum/v1/game/mic/close`,
  // 解除闭麦 - 林加汉 - ✔
  openMic: `/authApi/voiceforum/v1/game/mic/open`,
  // 查询目标用户的权限 - 苏昕 - ✔
  userGroup: `/authApi/voiceforum/v1/game/member/group`,
  // 添加管理员权限 - 苏昕 - ✔
  addGroup: `/authApi/voiceforum/v1/game/member/add`,
  // 移除管理员权限 - 苏昕 - ✔
  removeGroup: `/authApi/voiceforum/v1/game/member/remove/batch`,
  // 将用户踢出频道 - 李健 - ✔
  kickChannel: `/authApi/voiceforum/v1/game/kick/channel`,
  // 将用户踢出房间 - 李健 - ✔
  kickRoom: `/authApi/voiceforum/v1/game/kick/room`,
  // 麦克风开关 - 林加汉 - ✔
  micSwitch: `/authApi/voiceforum/v1/game/micSwitch`,
  // 扬声器开关 - 林加汉 - ✔
  speakerSwitch: `/authApi/voiceforum/v1/game/speakerSwitch`
};

export default voiceCommunity;
